<template lang="html">
  <v-app class="large-screen__body white">
    <div>
      <v-toolbar flat>
        <!-- left icons -->
        <v-btn flat icon @click="goTo"><i class="filter-icon pr-2"></i></v-btn>
        <v-btn flat icon><i class="search-icon pr-4"></i></v-btn>
        <v-spacer></v-spacer>
        <!-- center text -->
        <v-toolbar-title class="white--text">
          Messages
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

       <!-- tabs -->
      <v-tabs grow centered class="primary-tabs white--text">
       <v-tab :to = "{ name: 'Messages' }" :href="`#private`" class="white--text" @click="lastScroll=0">
         Private
       </v-tab>
       <v-tab :to = "{ name: 'MessageSquads' }" :href="`#squads`" class="white--text" @click="lastScroll=0">
        Channels
       </v-tab>
       <!-- <v-tab :to = "{ name: 'MessageMentions' }" :href="`#mentions`" class="white--text">
         Mentions
       </v-tab> -->
      </v-tabs>

      <v-tabs-items v-model="activeTabbar">
        <v-tab-item :id="`private`"  class="body">
          <v-list>
            <div v-if="!loadingPrivateMessages && noMessages" class="centered">
              <no-data-message>
                <v-icon slot="icon">speaker_notes</v-icon>
                <div slot="message">
                  No conversations available
                </div>
                <div slot="sub-message">
                  All direct conversation with users will be listed here
                </div>
              </no-data-message>
            </div>
            <template v-else v-for="item in privateMessages">
              <div class="list-tile" @click="openPrivateChat(item.convo_user_id)" v-scroll="onPrivateChatScroll">
                <v-list-tile-avatar>
                  <img v-if="getAvatar(item.convo_user_id)" :src="getAvatar(item.convo_user_id)">
                  <v-avatar size="40px" v-else class="red">
                    <span class="avatar-txt  white--text">{{ getUserNameInitials(item.convo_user_id) }}</span>
                  </v-avatar>
                </v-list-tile-avatar>
                <div class="list-content">
                  <v-list-tile-content>
                    <div class="name-time-container">
                      <span class="person-name">{{ getUserName(item.convo_user_id) }}</span>
                      <span class="message-time">{{ getTime(item.time) }}</span>
                    </div>
                    <!-- <v-list-tile-sub-title v-if="index<2" class="new-message">{{ item.subtitle }}</v-list-tile-sub-title> -->
                    <v-list-tile-sub-title>{{ item.value }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </div>
                <!-- <span v-if="index<2"class="new-message-notification"></span> -->
              </div>
            </template>
            <div v-if="loadingPrivateMessages" class="centered">
              <loader></loader>
            </div>
          </v-list>
        </v-tab-item>

        <v-tab-item :id="`squads`" class="body">
          <v-list>
            <div v-if="!loadingSquads && noSquads" class="centered">
              <no-data-message>
                <v-icon slot="icon">speaker_notes</v-icon>
                <div slot="message">
                  No channels available
                </div>
                <div slot="sub-message">
                  Project & Effort Channels you have participated in will be listed here
                </div>
              </no-data-message>
            </div>
            <template v-else v-for="(item, index) in squads">
              <div class="list-tile" @click="navigateToChatScreen(item)" v-scroll="onChannelChatScroll">
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.task_name  || item.project_name}}</v-list-tile-title>
                  <v-list-tile-sub-title class="squad-subtitle">
                    <v-layout row wrap>
                      <v-flex xs12 sm9 lg8>
                        <v-layout row wrap>
                          <v-flex sm4>
                            {{ item.chat_channel_area }}
                          </v-flex>
                          <!-- <v-flex sm4>
                            <img src="~icons/messages/profile.svg"></img>
                            {{ item.people }}
                          </v-flex>
                          <v-flex sm4>
                            <img src="~icons/messages/messages.svg"></img>
                            {{ item.messageText }}
                          </v-flex> -->
                      </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </div>
            </template>
            <div v-if="loadingSquads" class="centered">
              <loader></loader>
            </div>
          </v-list>
        </v-tab-item>

        <v-tab-item  :id="`mentions`" class="body white">
          <v-layout column>
            <v-list>
              <template v-for="(item, index) in mentions">
                <div class="list-tile">
                  <v-list-tile-avatar>
                    <v-avatar size="40px" class="red">
                      <span class="avatar-txt  white--text">{{ item.avatar }}</span>
                    </v-avatar>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-sub-title class="title-heading">{{ item.title }}</v-list-tile-sub-title>
                    <v-list-tile-sub-title class="squad-subtitle">{{ item.category }}</v-list-tile-sub-title>
                    <span v-if="index<2"class="new-message-notification"></span>
                    <v-list-tile-sub-title v-if="index<2" class="new-message">{{ item.messageText }}</v-list-tile-sub-title>
                    <v-list-tile-sub-title v-else>{{ item.messageText }}</v-list-tile-sub-title>
                    <v-list-tile-sub-title class="project-owner-text"> {{ item.author }} <span class="date-text">{{ item.time }}</span></v-list-tile-sub-title>
                  </v-list-tile-content>
                </div>
              </template>
            </v-list>
          </v-layout>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-app>
</template>

<script>
import moment from 'moment';
import Loader from '@/components/Loader';

export default {
  components: {
    Loader,
  },
  data() {
    return {
      lastScroll: 0,
      mentions: [
        {
          title: 'OP-89: Setup Trello',
          author: 'Valentino Pamarazzi',
          category: 'Project • Contributors',
          time: '17 min ago',
          avatar: 'OP',
          messageText: '@charleslingt, PDF will work. THanks!!',
        },
        {
          title: 'AJ-1: Schedule an appointment with Eduardo Messardi',
          category: 'Project • Followers',
          author: 'Valentino Pamarazzi',
          time: '1 hr ago',
          avatar: 'AJ',
          messageText: 'We can ask several people to join our project. One of the best managers I know is @charleslingt. I hope he is interested.',
        },
        {
          title: 'KK-81: Vue.js integration notes',
          category: 'Effort • Followers',
          time: '28 min ago',
          author: 'Andrej Rossolnikov',
          avatar: 'KK',
          messageText: 'I can invite @charleslingt. I think he’d help to launch our product.',
        },
      ],
    };
  },
  methods: {
    onPrivateChatScroll() {
      const scroll = this.$scrollPercent();
      const scrollingUp = this.lastScroll > scroll;
      this.lastScroll = scroll;
      this.showFindEffortButton = scroll > 0.2;

      if (scroll < 0.90 || scrollingUp) return null;

      this.$store.dispatch('messages/getPrivateChatList');
      return null;
    },
    onChannelChatScroll() {
      const scroll = this.$scrollPercent();
      const scrollingUp = this.lastScroll > scroll;
      this.lastScroll = scroll;
      this.showFindEffortButton = scroll > 0.2;

      if (scroll < 0.90 || scrollingUp) return null;

      this.$store.dispatch('messages/chatGetUserChannels');
      return null;
    },
    navigateToChatScreen(item) {
      if (item.chat_channel_area === 'Project') {
        this.$router.push({ name: 'ProjectChat', params: { id: item.project_id } });
      } else if (item.chat_channel_area === 'Task') {
        this.$router.push({ name: 'TaskDetailsChat', params: { id: item.task_id } });
      }
    },
    goTo() {
      this.$router.push({ path: '/messages/filter', name: 'MessageFilter' });
    },
    getUserName(userId) {
      for (let i = 0; i < this.userProfiles.length; i += 1) {
        if (this.userProfiles[i].user_id === userId) {
          return this.userProfiles[i].username;
        }
      }
      return 'No Name';
    },
    openPrivateChat(userId) {
      this.$router.push({ name: 'MessagePrivateChat', params: { id: userId } });
    },
    getAvatar(userId) {
      let avatar = null;
      for (let i = 0; i < this.userProfiles.length; i += 1) {
        if (this.userProfiles[i].user_id === userId) {
          avatar = this.userProfiles[i].avatar;
        }
      }
      return avatar;
    },
    getUserNameInitials(userId) {
      for (let i = 0; i < this.userProfiles.length; i += 1) {
        if (this.userProfiles[i].user_id === userId) {
          return this.userProfiles[i].username.substring(0, 2).toUpperCase();
        }
      }
      return 'NN';
    },
    getTime(time) {
      return moment.utc(time).fromNow();
    },
  },
  computed: {
    activeTabbar() {
      return this.$route.meta.query.activeTabbar || 'private';
    },
    squads() {
      return this.$store.getters['messages/squads'];
    },
    loadingSquads() {
      return this.$store.getters['messages/loadingSquads'];
    },
    loadingPrivateMessages() {
      return this.$store.getters['messages/loadingPrivateMessages'];
    },
    userProfiles() {
      return this.$store.getters['messages/userProfiles'];
    },
    privateMessages() {
      return this.$store.getters['messages/privateMessages'];
    },
    noMessages() {
      return this.privateMessages.length === 0;
    },
    noSquads() {
      return this.squads.length === 0;
    },
  },
  mounted() {
    this.$store.dispatch('messages/chatGetUserChannels');
    this.$store.dispatch('messages/getPrivateChatList');
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";
#app {
    .avatar-txt {
      font-size: 16px;
    }
    .list .list__tile__sub-title.title-heading {
      color: $blue;
      font-size: 16px;
    }
    .squad-subtitle {
      color: $header;
    }
    .new-message {
      color: black;
    }
    .message-time {
      font-size:13px;
      color: #b2bac2;
      padding-left: 9px;
      padding-top: 3px;
    }
    .chat-loader-holder {
      align-self: center;
    }
    .half-circle-spinner-chat {
      width: 30px;
      height: 30px;
      margin:0px;
    }
    .new-message-notification {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-left: auto;
      background-color: #fe2659;
    }
    .appear {
      position: fixed;
      right: 24px;
      bottom: 73px;
      display: none;
    }
    .show {
      display: inherit;
    }
    .task-view {
      .list__tile__content {
        color: $blue;
        font-size: 16px;
        span {
          font-size: 10px;
        }
        div {
          font-size: 16px;
          color: $blue;
        }
        .strike-text {
          color: $header;
        }
      }
    }
    .left-contributors {
      border-radius: 50%;
      border: 2px solid white;
      background: $blue;
      height: 40px;
      margin-left: -7px;
      text-align: center;
      width: 40px;
      span {
        position: relative;
        top: 2px;
        left: 2px;
      }
    }
    .contributors-area {
      span {
        margin-left: -7px;
        font-size: 20px;
      }
      img {
        height: 40px;
        width: 40px;
        border-radius: 50%;
        border: 2px solid white;
      }
    }
    .status{
      border-radius:3px;
      padding: 3px;
      color: white;
    }
    .completed {
      background: #6fae36;
    }
    .edit {
      margin-top: auto;
      margin-left: -7px;
      margin-top: 12px;
      margin-bottom: 16px;
      span {
        font-size: 13px;
        font-family: MuseoSans-500;
        color: $blue;
      }
    }
    .all-contributors-btn {
      span {
        font-size: 16px;
        font-family: MuseoSans-500;
        color: $blue;
      }
    }
    .list-content {
      width: 100%;
    }
    .project-description {
      font-size:20px;
    }
    .toolbar__title {
      text-align: center;
      white-space: initial;
      margin-right: 76px;
    }
    .project-owner-text {
      color: black;
      font-weight: bold;
      font-size: 13px;
    }
    .date-text {
      color: $header;
      font-weight: normal;
    }
    .name-time-container {
      width: 100%;
      display: flex;
      flex-direction: row;
    }
    .list-tile {
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      color: inherit;
      min-height: 48px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      font-size: 16px;
      font-weight: 400;
      height: auto;
      margin: 0;
      padding-top: 14px;
      padding-bottom: 14px;
      position: relative;
      text-decoration: none;
      -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      border-bottom: 1px solid $lighter;
      cursor: pointer;
    }
    .list__tile__avatar {
      margin-bottom: auto;
    }
    .list .list__tile__sub-title, .application .theme--light.list .list__tile__sub-title {
      font-size:13px;
      white-space: inherit;
      word-break: break-word;
    }
    .list .list__tile__title, .application .theme--light.list .list__tile__title {
      color: $blue;
      font-size: 16px;
    }
    .body {
      padding-top: 10px;
      padding-left: 29px;
      padding-right: 29px;
    }

    .follow-project {
      background: transparent;
      width: 20%;
      padding: 8px;
      height: auto;
      margin-bottom:24px;
      border-radius:24px 24px 24px 24px;
      background-color: white;
      box-shadow: none;
      color: $blue;
      .btn__content {
           opacity: 0;
        }
    }
    .person-name {
      font-size:16px;
      color: $blue;
    }

    a{
      text-decoration: none;
    }

    .list-border {
      min-height: 10px;
      border-bottom: 0px solid $lighter;
    }

    .centered {
      display: flex;
      justify-content: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Messages.vue